import { createApp } from 'vue';
import setupSentry from '@/modules/setupSentry';
import { locales } from '@/modules/locales/setup';
import App from '@/App';
import store from '@/store';
import router from '@/router';

const app = createApp(App);
app.use(locales.i18n);
app.use(store);
app.use(router);

// eslint-disable-next-line no-constant-condition
if (process.env.NODE_ENV !== 'development' && false) {
    setupSentry(app);
}

app.mount('#app');
